import styles from './index.less';
import { FC } from 'react';

interface PaymentFooterProps {
  paymentClick: () => void;
}
const PaymentFooter: FC<PaymentFooterProps> = (props) => {
  const { paymentClick } = props;
  return (
    <div className={styles.container}>
      <div onClick={paymentClick} className={styles.btn}>
        立即充值
      </div>
    </div>
  );
};

export default PaymentFooter;
